class Modal {
  constructor(event, data) {
    this.event = event;
    this.data = data;
  }

  googleFormat() {
    const googleFormattedData = {};
    switch (this.event) {
      case 'modalClosed': {
        googleFormattedData.event = this.data.eventInfo.eventName;
        googleFormattedData.modalId = this.data.attributes.modalId;
        googleFormattedData.modalName = this.data.attributes.modalName;

        break;
      }

      case 'modalOpened': {
        googleFormattedData.event = this.data.eventInfo.eventName;
        googleFormattedData.modalId = this.data.attributes.modalId;
        googleFormattedData.modalName = this.data.attributes.modalName;

        break;
      }

      default:
        throw Error(`Event ${this.event} is not registered`);
    }
    return googleFormattedData;
  }
}

export default Modal;
